var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTicketStateWonIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon ticket-state-won-icon",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 13,
    fill: "#32C24D",
    className: "fill-circle"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-symbol",
    fill: "#fff",
    d: "M9.882 15.023l7.865-7.864a.857.857 0 011.212 1.212l-8.47 8.47a.857.857 0 01-1.213 0l-4.235-4.235a.857.857 0 111.212-1.212l3.63 3.63z"
  }))));
}

export default SvgTicketStateWonIconSv;